const summerGamePage = document.querySelector('.summer-promo--game')

if(summerGamePage) {
    const gameSubheading = summerGamePage.querySelector('.js-summer-promo-game-intro-text-subheading');
    const gameHeading = summerGamePage.querySelector('.js-summer-promo-game-intro-text-heading');
    const gameBtnsHeading = summerGamePage.querySelector('.js-summer-promo-countdown-heading');
    const gameSunAsset = summerGamePage.querySelector('.js-summer-promo-game-intro-sun');
    const gameCharacterAsset = summerGamePage.querySelector('.js-summer-promo-game-intro-character');

    const gameBtns = summerGamePage.querySelectorAll('.js-summer-btn');

    function animateElements(elements, delayStart, className, stagger = 150) {
        setTimeout(() => {
            elements.forEach((el, index) => {
                setTimeout(() => {
                    el.classList.add(className);
                }, index * stagger);
            });
        }, delayStart);
    }

    window.addEventListener('load', () => {
        if (summerGamePage) {
            if (gameSubheading) {
                setTimeout(() => {
                    gameSubheading.classList.add('reveal-bottom-to-top');
                }, 600);
            }

            if (gameHeading) {
                setTimeout(() => {
                    gameHeading.classList.add('reveal-bottom-to-top');
                }, 700);
            }

            if (gameBtnsHeading) {
                setTimeout(() => {
                    gameBtnsHeading.classList.add('reveal-bottom-to-top');
                }, 800);
            }

            if (gameBtns.length > 0) {
                animateElements(gameBtns, 900, 'pop-in');
            }

            if(gameSunAsset) {
                setTimeout(() => {
                    gameSunAsset.classList.add('animate');
                }, 500);
            }

            // if(gameCharacterAsset) {
            //     setTimeout(() => {
            //         gameCharacterAsset.classList.add('animate');
            //     }, 500);
            // }
        }
    });
}
